import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from "@/hooks/useTranslation";

type CardInventoryErrorProps = {
  onRetry: () => void;
};

/** Error card with a retry action, shown when the license inventory fails to load. */
export const CardInventoryError = ({ onRetry }: CardInventoryErrorProps) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent className="p-5 flex items-center justify-between gap-3">
        <p className="text-sm text-muted-foreground">
          {t("team.licenseManagement.loadError")}
        </p>
        <Button variant="outline" size="sm" onClick={onRetry}>
          {t("team.licenseManagement.retry")}
        </Button>
      </CardContent>
    </Card>
  );
};
